import enProfileSearchCard from '@components/profile-search-card/locales/en.json'
import esProfileSearchCard from '@components/profile-search-card/locales/es.json'
import ptProfileSearchCard from '@components/profile-search-card/locales/pt.json'
import enProfileProgressivePage from '@pages/profile-progressive/locales/en.json'
import esProfileProgressivePage from '@pages/profile-progressive/locales/es.json'
import ptProfileProgressivePage from '@pages/profile-progressive/locales/pt.json'
import enProfileNav from '@pages/profile/locales/en.json'
import esProfileNav from '@pages/profile/locales/es.json'
import ptProfileNav from '@pages/profile/locales/pt.json'
import enBannerSocialNetwork from '@src/components/banner-social-network/locales/en.json'
import esBannerSocialNetwork from '@src/components/banner-social-network/locales/es.json'
import ptBannerSocialNetwork from '@src/components/banner-social-network/locales/pt.json'
import enCardSocialNetwork from '@src/components/card-social-network/locales/en.json'
import esCardSocialNetwork from '@src/components/card-social-network/locales/es.json'
import ptCardSocialNetwork from '@src/components/card-social-network/locales/pt.json'
import enModalEditCategoriesSocialNetwork from '@src/components/modal-edit-categories-social-network/locales/en.json'
import esModalEditCategoriesSocialNetwork from '@src/components/modal-edit-categories-social-network/locales/es.json'
import ptModalEditCategoriesSocialNetwork from '@src/components/modal-edit-categories-social-network/locales/pt.json'
import enModalUpdateConfiguration from '@src/components/modal-update-configuration/locales/en.json'
import esModalUpdateConfiguration from '@src/components/modal-update-configuration/locales/es.json'
import ptModalUpdateConfiguration from '@src/components/modal-update-configuration/locales/pt.json'
import enPhoneValidation from '@src/pages/profile/components/phone-validation/locales/en.json'
import esPhoneValidation from '@src/pages/profile/components/phone-validation/locales/es.json'
import ptPhoneValidation from '@src/pages/profile/components/phone-validation/locales/pt.json'
import enAddressPage from '@src/pages/profile/pages/address/locales/en.json'
import esAddressPage from '@src/pages/profile/pages/address/locales/es.json'
import ptAddressPage from '@src/pages/profile/pages/address/locales/pt.json'
import enProfilePage from '@src/pages/profile/pages/data/locales/en.json'
import esProfilePage from '@src/pages/profile/pages/data/locales/es.json'
import ptProfilePage from '@src/pages/profile/pages/data/locales/pt.json'
import enDeletePage from '@src/pages/profile/pages/delete/locales/en.json'
import esDeletePage from '@src/pages/profile/pages/delete/locales/es.json'
import ptDeletePage from '@src/pages/profile/pages/delete/locales/pt.json'
import enNotificationsFormPage from '@src/pages/profile/pages/notifications-form/locales/en.json'
import esNotificationsFormPage from '@src/pages/profile/pages/notifications-form/locales/es.json'
import ptNotificationsFormPage from '@src/pages/profile/pages/notifications-form/locales/pt.json'
import enPasswordPage from '@src/pages/profile/pages/password/locales/en.json'
import esPasswordPage from '@src/pages/profile/pages/password/locales/es.json'
import ptPasswordPage from '@src/pages/profile/pages/password/locales/pt.json'
import enSocialNetworksPage from '@src/pages/social-networks/locales/en.json'
import esSocialNetworksPage from '@src/pages/social-networks/locales/es.json'
import ptSocialNetworksPage from '@src/pages/social-networks/locales/pt.json'
import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import enGlobal from './assets/locales/en.json'
import esGlobal from './assets/locales/es.json'
import ptGlobal from './assets/locales/pt.json'
import enProfileCache from './components/profile-cache/locales/en.json'
import esProfileCache from './components/profile-cache/locales/es.json'
import ptProfileCache from './components/profile-cache/locales/pt.json'

export const defaultNS = 'defaultProfile'
export const resources = {
  en: {
    defaultProfile: enGlobal,
    profileNav: enProfileNav,
    phoneValidation: enPhoneValidation,
    profilePage: enProfilePage,
    passwordPage: enPasswordPage,
    notificationsFormPage: enNotificationsFormPage,
    addressPage: enAddressPage,
    deletePage: enDeletePage,
    bannerSocialNetwork: enBannerSocialNetwork,
    socialNetworksPage: enSocialNetworksPage,
    cardSocialNetwork: enCardSocialNetwork,
    profileSearchCard: enProfileSearchCard,
    modalEditCategoriesSocialNetwork: enModalEditCategoriesSocialNetwork,
    modalUpdateConfiguration: enModalUpdateConfiguration,
    profileProgressivePage: enProfileProgressivePage,
    profileCache: enProfileCache,
  },
  pt: {
    defaultProfile: ptGlobal,
    profileNav: ptProfileNav,
    phoneValidation: ptPhoneValidation,
    profilePage: ptProfilePage,
    passwordPage: ptPasswordPage,
    notificationsFormPage: ptNotificationsFormPage,
    addressPage: ptAddressPage,
    deletePage: ptDeletePage,
    bannerSocialNetwork: ptBannerSocialNetwork,
    socialNetworksPage: ptSocialNetworksPage,
    cardSocialNetwork: ptCardSocialNetwork,
    profileSearchCard: ptProfileSearchCard,
    modalEditCategoriesSocialNetwork: ptModalEditCategoriesSocialNetwork,
    modalUpdateConfiguration: ptModalUpdateConfiguration,
    profileProgressivePage: ptProfileProgressivePage,
    profileCache: ptProfileCache,
  },
  es: {
    defaultProfile: esGlobal,
    profileNav: esProfileNav,
    phoneValidation: esPhoneValidation,
    profilePage: esProfilePage,
    passwordPage: esPasswordPage,
    notificationsFormPage: esNotificationsFormPage,
    addressPage: esAddressPage,
    deletePage: esDeletePage,
    bannerSocialNetwork: esBannerSocialNetwork,
    socialNetworksPage: esSocialNetworksPage,
    cardSocialNetwork: esCardSocialNetwork,
    profileSearchCard: esProfileSearchCard,
    modalEditCategoriesSocialNetwork: esModalEditCategoriesSocialNetwork,
    modalUpdateConfiguration: esModalUpdateConfiguration,
    profileProgressivePage: esProfileProgressivePage,
    profileCache: esProfileCache,
  },
} as const

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    defaultNS,
    ns: [
      'defaultProfile',
      'profileNav',
      'phoneValidation',
      'passwordPage',
      'notificationsFormPage',
      'addressPage',
      'deletePage',
      'bannerSocialNetwork',
      'socialNetworksPage',
      'cardSocialNetwork',
      'profileSearchCard',
      'modalEditCategoriesSocialNetwork',
      'modalUpdateConfiguration',
      'profileProgressivePage',
      'profileCache',
    ],
    load: 'all',
    supportedLngs: ['en', 'es', 'pt'],
    lng: navigator.language?.split('-')[0] || 'en',
    fallbackLng: 'en',
    debug: false,
    cache: {
      enabled: false,
    },
    resources,
  })

export default i18n
